import React, { useState, useEffect, useRef } from 'react';
import { View, Text, TextInput, TouchableOpacity, FlatList, StyleSheet } from 'react-native';
import { fetchMessages } from '../utils/api';
import { io } from 'socket.io-client';
import { SOCKET_URL } from '../utils/api';

const ChatScreen = ({ route }) => {
    const { chatId, userId } = route.params;
    const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState('');
    const socketRef = useRef(null);
    const flatListRef = useRef(null);

    useEffect(() => {
        // Cargar mensajes iniciales
        const loadMessages = async () => {
            try {
                const fetched = await fetchMessages(chatId);
                setMessages(fetched);
            } catch (e) {
                console.error('Error cargando mensajes:', e);
            }
        };
        loadMessages();

        // Conectar WebSocket
        socketRef.current = io(SOCKET_URL, { transports: ['websocket'] });
        socketRef.current.emit('join_group', { group_id: chatId });

        socketRef.current.on('new_message', (data) => {
            setMessages((prev) => [...prev, data]);
        });

        return () => {
            if (socketRef.current) {
                socketRef.current.disconnect();
            }
        };
    }, [chatId]);

    const handleSendMessage = () => {
        const text = newMessage.trim();
        if (!text || !socketRef.current) return;

        const msgData = {
            group_id: chatId,
            user_id: userId,
            content: text,
            timestamp: new Date().toISOString(),
        };
        socketRef.current.emit('send_message', msgData);
        setNewMessage('');
    };

    const renderMessage = ({ item }) => {
        const isOwn = item.user_id === userId;
        return (
            <View style={[styles.messageContainer, isOwn ? styles.ownMessage : styles.otherMessage]}>
                <Text style={styles.messageText}>{item.content || item.text}</Text>
                {item.timestamp ? (
                    <Text style={styles.timestamp}>
                        {new Date(item.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                    </Text>
                ) : null}
            </View>
        );
    };

    return (
        <View style={styles.container}>
            <FlatList
                ref={flatListRef}
                data={messages}
                keyExtractor={(item, index) => (item.id ? item.id.toString() : index.toString())}
                renderItem={renderMessage}
                onContentSizeChange={() => flatListRef.current?.scrollToEnd({ animated: true })}
            />
            <View style={styles.inputRow}>
                <TextInput
                    style={styles.input}
                    placeholder="Escribir mensaje..."
                    value={newMessage}
                    onChangeText={setNewMessage}
                    onSubmitEditing={handleSendMessage}
                    returnKeyType="send"
                />
                <TouchableOpacity style={styles.sendButton} onPress={handleSendMessage}>
                    <Text style={styles.sendButtonText}>Enviar</Text>
                </TouchableOpacity>
            </View>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
        padding: 10,
        backgroundColor: '#ECE5DD',
    },
    messageContainer: {
        marginVertical: 4,
        padding: 10,
        borderRadius: 8,
        maxWidth: '80%',
    },
    ownMessage: {
        backgroundColor: '#DCF8C6',
        alignSelf: 'flex-end',
    },
    otherMessage: {
        backgroundColor: '#FFFFFF',
        alignSelf: 'flex-start',
    },
    messageText: {
        fontSize: 15,
    },
    timestamp: {
        fontSize: 11,
        color: '#999',
        marginTop: 4,
        textAlign: 'right',
    },
    inputRow: {
        flexDirection: 'row',
        alignItems: 'center',
        borderTopWidth: 1,
        borderTopColor: '#ccc',
        paddingTop: 8,
        backgroundColor: '#fff',
    },
    input: {
        flex: 1,
        height: 40,
        borderColor: 'gray',
        borderWidth: 1,
        borderRadius: 20,
        paddingHorizontal: 14,
        marginRight: 8,
    },
    sendButton: {
        backgroundColor: '#25D366',
        borderRadius: 20,
        paddingHorizontal: 16,
        paddingVertical: 10,
    },
    sendButtonText: {
        color: '#fff',
        fontWeight: 'bold',
    },
});

export default ChatScreen;